import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Gift, ArrowRight } from "lucide-react";

export default function GiftsIndex() {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/landing").then(({ data }) => {
      setPages(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gifts-index-page">
      <section className="border-b border-[#E3DCD2] bg-[#F3EFEA]/40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <div className="text-[11px] uppercase tracking-widest-plus text-[#D27D60] mb-3 flex items-center gap-2">
            <Gift className="w-3.5 h-3.5" strokeWidth={1.5} /> ✦ Curated occasions
          </div>
          <h1 className="font-serif-display text-6xl md:text-7xl leading-[0.95] max-w-3xl">
            Gifts for every <em className="text-[#D27D60]">moment</em>.
          </h1>
          <p className="text-base text-[#4a4a4a] mt-5 max-w-lg">
            Handpicked collections for Rakhi, Diwali, Christmas, weddings and everything in between.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[0,1,2].map(i => <div key={i} className="animate-pulse aspect-[4/3] bg-[#F3EFEA] rounded-lg" />)}
          </div>
        ) : pages.length === 0 ? (
          <div className="text-center py-20">
            <p className="font-serif-display text-3xl mb-3">Seasonal collections coming soon</p>
            <p className="text-sm text-[#9BA595] mb-6">In the meantime, explore our full shop.</p>
            <Link to="/shop" className="text-sm underline underline-offset-8 hover:text-[#D27D60]" data-testid="gifts-empty-shop-link">Shop everything</Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {pages.map((p) => (
              <Link
                key={p.id}
                to={`/gifts/${p.slug}`}
                className="group relative aspect-[4/5] rounded-lg overflow-hidden hover-lift-img"
                style={{ backgroundColor: `${p.theme_color}20` }}
                data-testid={`gifts-index-card-${p.slug}`}
              >
                {p.hero_image && (
                  <img src={p.hero_image} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-[#FDFBF7]">
                  {p.subtitle && (
                    <div className="text-[10px] uppercase tracking-widest-plus opacity-80 mb-2">
                      ✦ {p.subtitle}
                    </div>
                  )}
                  <div className="font-serif-display text-4xl leading-tight mb-3">{p.title}</div>
                  <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest-plus">
                    Explore
                    <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
